import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import schoolERP1 from "../assets/images/gurukulerp.png";
import schoolERP2 from "../assets/images/gurukulerp2.png";
import schoolERPlogo from "../assets/images/Gurukul erp img logo.jpg.jpeg";

import billing1 from "../assets/images/billingsoftware1.jpeg";
import billing2 from "../assets/images/billingsoftware2.jpeg";
import billinglogo from "../assets/images/bt erp img logo.jpg.jpeg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import Hero from "../pages/Hero";
import heroimg from "../assets/images/herobg.jpg";

import Advertisement from "../components/Advertise";
import { Helmet } from "react-helmet-async";

const Products = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🔹 Scroll to hash if present (for ad click navigation)
  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace("#", ""));
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  const products = [
    {
      id: "gurukul-erp",
      title: "GuruKul School ERP",
      images: [schoolERPlogo, schoolERP1, schoolERP2],
      link: "http://www.gurukulerp.in/",
      description:
        "A complete school management ERP designed to automate academic, administrative, and communication processes efficiently."
    },
    {
      id: "beacon-track", // 🔹 important for ad navigation
      title: "Beacon Track - Billing Software",
      images: [billinglogo, billing1, billing2],
      link: "https://billingsoftware-iskt.onrender.com",
      description:
        "Simple, fast, and powerful billing software for managing invoices, inventory, and daily business operations."
    }
  ];

  return (
    <div className="products-page">


      <Helmet>
  <title>Software Products & Digital Solutions | Softcoders</title>

  <meta
    name="description"
    content="Explore software products and digital solutions by Softcoders designed to automate operations, improve efficiency, and support business growth."
  />

  <meta
    name="keywords"
    content="software products, business software solutions, digital solutions, automation software, enterprise software, custom software systems"
  />

  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://softcoders.in/products" />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Softcoders Software Products" />
  <meta
    property="og:description"
    content="Modern software solutions designed for automation, scalability, and performance."
  />
  <meta property="og:url" content="https://softcoders.in/products" />
  <meta property="og:image" content="https://softcoders.in/logo.png" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Softcoders Software Products" />
  <meta
    name="twitter:description"
    content="Explore powerful digital solutions for modern businesses."
  />
  <meta name="twitter:image" content="https://softcoders.in/logo.png" />

  {/* Structured Data */}
  <script type="application/ld+json">
    {`
    {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Software Products",
      "description": "Digital software solutions developed by Softcoders",
      "brand": {
        "@type": "Organization",
        "name": "Softcoders"
      }
    }
    `}
  </script>
</Helmet>


      {/* HERO */}
      <Hero
        title="Our Products"
        subtitle="Powerful software solutions built to simplify school management and business operations."
        image={heroimg}
      />

      {/* PRODUCTS */}
      <div className="products-container">
        {products.map((product, index) => (
          <div
            id={product.id} // 🔹 added for hash navigation
            key={product.id}
            className={`product-card ${index % 2 !== 0 ? "reverse" : ""}`}
          >
            {/* IMAGE */}
            <div className="product-image">
              <Swiper
                modules={[Autoplay, Pagination]}
                pagination={{ clickable: true }}
                autoplay={{ delay: 2500 }}
              >
                {product.images.map((img, i) => (
                  <SwiperSlide key={i}>
                    <img src={img} alt={product.title} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {/* CONTENT */}
            <div className="product-content">
              <h2>{product.title}</h2>
              <p>{product.description}</p>

              <ul>
                <li>Cloud Based System</li>
                <li>Role Based Access Control</li>
                <li>Detailed Reports & Analytics</li>
                <li>Secure Database</li>
              </ul>

              <button
                className="product-btn"
                onClick={() => {
                  if (product.link.startsWith("http")) {
                    window.open(product.link, "_blank");
                  } else {
                    navigate(product.link);
                  }
                }}
              >
                View More
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* CTA */}
      <section className="cta-section">
        <div className="cta-box">

          {/* LEFT CONTENT */}
          <div className="cta-left">
            <h2>Need a Custom Software Solution?</h2>
            <p>
              Our team can build tailored solutions to fit your exact business needs.
            </p>
            <a href="/contact" className="btn-primary">
              Contact Our Team
            </a>
          </div>

          {/* RIGHT AD */}
          <div className="cta-right">
            <Advertisement />
          </div>

        </div>
      </section>
    </div>
  );
};

export default Products;